import React, { useCallback, useState } from "react";

import DetachedModal from "../../../Shared/Modals/DetachedModal/DetachedModal";

import { SpaceScannerStage1 } from "./SpaceScannerStage1/SpaceScannerStage1";
import { SpaceScannerStage2 } from "./SpaceScannerStage2/SpaceScannerStage2";
import { SpaceScannerResult } from "./SpaceScannerResult/SpaceScannerResult";
import {
  ProcessedScanResult,
  ScanResults,
  ScanConfiguration,
  OriginalAssignment
} from "./SpaceScanner.types";
/**
 * Space Scanner Modal Props
 */
type SpaceScannerModalProps = {
  onClose: () => void;
};

/**
 * Space Scanner Modal
 *
 * @param param0
 * @returns
 */
export const SpaceScannerModal = ({ onClose }: SpaceScannerModalProps) => {
  const [currentView, setCurrentView] = useState<number>(0);
  const [scannerResult, setScannerResult] = useState<ProcessedScanResult[]>([]);
  const [scanConfig, setScanConfig] = useState<ScanConfiguration>({
    allowOverCapacity: false,
    searchSeatedCapacity: false
  });
  const [originalAssignments, setOriginalAssignments] = useState<
    OriginalAssignment[]
  >([]);

  /**
   * Handle on close
   */
  const handleOnClose = useCallback(() => {
    onClose();
  }, [onClose]);

  /**
   * Handle on result
   */
  const handleOnResult = useCallback(
    (result: ProcessedScanResult[], config: ScanConfiguration) => {
      setScannerResult(result);
      setScanConfig(config);
      const assignments: OriginalAssignment[] = result.map((r) => ({
        bookingId: r.booking._id,
        previousAreas: r.previousAreas
      }));
      setOriginalAssignments(assignments);
      setCurrentView(1);
    },
    []
  );

  /**
   * Handle on completed
   */
  const handleOnCompleted = useCallback((result: ScanResults) => {
    setScannerResult(Array.isArray(result) ? result : result.results);
    setCurrentView(2);
  }, []);

  /**
   * Handle go back
   */
  const handleGoBack = useCallback(() => {
    if (currentView === 0) {
      onClose();
      return;
    }

    setCurrentView(currentView - 1);
  }, [currentView, onClose]);

  return (
    <DetachedModal
      handleClose={handleOnClose}
      heading={`Space Optimiser (${currentView === 0 ? "1" : "2"}/2)`}
      width="90%"
    >
      <>
        {currentView === 0 && (
          <SpaceScannerStage1
            onClose={() => {
              onClose();
            }}
            onResult={handleOnResult}
          />
        )}
        {currentView === 1 && (
          <SpaceScannerStage2
            onGoBack={handleGoBack}
            result={scannerResult}
            onCompleted={handleOnCompleted}
            onClose={handleOnClose}
            scanConfig={scanConfig}
            originalAssignments={originalAssignments}
          />
        )}
        {currentView === 2 && (
          <SpaceScannerResult result={scannerResult} onClose={handleOnClose} />
        )}
      </>
    </DetachedModal>
  );
};
